import * as React from 'react';
import { CountryGroup, RatesColumn } from 'app/pages/AgentPricing/models';

interface RatesTableHeaderProps {
   countries: CountryGroup[]
   columns: RatesColumn[]
   highlightColumnId?: string
}

export default function RatesTableHeader(props: RatesTableHeaderProps){
    return <thead>
        <tr>
            <th className="empty-cell"></th>
            {props.countries.map(x => {
                return x.columns.length > 1 
                    ? <th key={x.name} colSpan={x.columns.length}>{x.name}</th>
                    : <th key={x.name}>{x.name}</th>
            })}
        </tr>
        <tr>
            <th className="empty-cell"></th>
            {props.columns.map(x => { 
                return <th className={props.highlightColumnId === x.id ? 'selected' : undefined} key={x.id}>{x.name}</th> 
            })}
        </tr>
    </thead>
}





